import { useState } from 'react';
import { sectionIDs } from '../../../constants/section-ids.constants';
import { exportUserData } from '../../../helpers/exportUserData';
import DeleteAccount from '../../Buttons/DeleteAccount';
import ButtonComponent from '../../UI/Button/Button.component';

interface AccountViewProps {
  username: string;
  handleClickOpen: () => void;
}

export const AccountView = (props: AccountViewProps) => {
  const { username, handleClickOpen } = props;
  const [exporting, setExporting] = useState(false);

  const handleDownload = async () => {
    setExporting(true);
    try {
      await exportUserData(username);
    } catch (e) {
      console.error('Data export failed', e);
    } finally {
      setExporting(false);
    }
  };

  // TRIL-152: the deleteUser resolver now exists, but account deletion does
  // NOT yet cascade — a real delete would orphan the user's posts / replies /
  // drafts / follower edges and leave their denormalized PII (username, avatar
  // key, bio) on every post row. Keep the control hidden until the cascade /
  // anonymize follow-up (TRIL-334) lands; set VITE_ENABLE_ACCOUNT_DELETION=true
  // to re-enable.
  const accountDeletionEnabled =
    import.meta.env.VITE_ENABLE_ACCOUNT_DELETION === 'true';
  return (
    <section id={sectionIDs.ACCOUNT_VIEW}>
      <div>Account view for username: {username}</div>
      <ButtonComponent
        variant="outline"
        onClick={handleDownload}
        disabled={exporting}
      >
        {exporting ? 'Preparing your data…' : 'Download my data'}
      </ButtonComponent>
      {accountDeletionEnabled && <DeleteAccount onClick={handleClickOpen} />}
    </section>
  );
};
